import { FeatureFlag } from 'types';

import { useFeatureFlags } from './useFeatureFlags';

/** A boolean flag from the effective set; see `useFeatureFlags` for the sources. */
export function useFeatureFlag(flag: FeatureFlag): boolean {
  return Boolean(useFeatureFlags()[flag]);
}
